import styled from 'styled-components'
import * as C from '../util/Colors'

export const BtnNew = styled.div`
    position: fixed;
    background-color: ${C.BLUE};
    bottom: 30px;
    right: 30px;
    width: 200px;
    height:60px;
    display:flex;
    justify-content: center;
    align-items: center;
    color:white;
    border-radius: 2.25rem;
    cursor:pointer;
    -moz-transition: all .2s ease-in;
    -o-transition: all .2s ease-in;
    -webkit-transition: all .2s ease-in;
    transition: all .2s ease-in;
    font-size: 1.5rem;

    &:hover{
        background-color:${C.HOVERBTN};
        font-size: 22px;
        width: 210px;
        height:65px;
        font-size: 1.7rem;
    }
`

export const RESETPASS = styled.h2`
    color: ${C.BLUE};
    font-size: 1.3rem;
    cursor:pointer;
    margin: 10px 20px;

    &:hover{
        color:${C.HOVERBTN};
    }
`

export const BoxFormInteral = styled.div`
    width: 50%;
    margin: 5rem auto;
`